exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fixed-height-tab[data-v-1ff0b8c8]{height:60vh;overflow-y:auto}", ""]);

// exports
